import React from 'react';
import { Select } from '../ui/select';

interface FilterBarProps {
  selectedYear?: number;
  selectedCountry?: string;
  selectedRegion?: string;
  availableYears?: number[];
  availableCountries?: string[];
  availableRegions?: string[];
  onYearChange?: (year: number) => void;
  onCountryChange?: (country: string) => void;
  onRegionChange?: (region: string) => void;
}

export function FilterBar({
  selectedYear,
  selectedCountry,
  selectedRegion,
  availableYears = [],
  availableCountries = [],
  availableRegions = [],
  onYearChange,
  onCountryChange,
  onRegionChange
}: FilterBarProps) {
  return (
    <div className="bg-green-100 border border-green-200 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        {/* Year Filter */}
        <div className="flex-1 min-w-0">
          <label className="block text-sm font-medium text-green-800 mb-1">
            Year
          </label>
          <Select
            value={selectedYear?.toString() || ''}
            onChange={(e) => onYearChange?.(parseInt(e.target.value))}
            options={[
              { value: '', label: 'Select Year' },
              ...availableYears.map(year => ({
                value: year.toString(),
                label: year.toString()
              }))
            ]}
            className="w-full bg-white border-green-300 text-green-800 focus:border-green-500 focus:ring-green-500"
          />
        </div>

        {/* Country Filter */}
        <div className="flex-1 min-w-0">
          <label className="block text-sm font-medium text-green-800 mb-1">
            Country
          </label>
          <Select
            value={selectedCountry || ''}
            onChange={(e) => onCountryChange?.(e.target.value)}
            options={[
              { value: '', label: 'All Countries' },
              ...availableCountries.map(country => ({
                value: country,
                label: country
              }))
            ]}
            className="w-full bg-white border-green-300 text-green-800 focus:border-green-500 focus:ring-green-500"
          />
        </div>

        {/* Region Filter */}
        <div className="flex-1 min-w-0">
          <label className="block text-sm font-medium text-green-800 mb-1">
            Region
          </label>
          <Select
            value={selectedRegion || ''}
            onChange={(e) => onRegionChange?.(e.target.value)}
            options={[
              { value: '', label: 'All Regions' },
              ...availableRegions.map(region => ({
                value: region,
                label: region
              }))
            ]}
            className="w-full bg-white border-green-300 text-green-800 focus:border-green-500 focus:ring-green-500"
          />
        </div>

        {/* Filter Icon */}
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-green-200 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}













